import md5 from "js-md5";
import axios from "axios";
import { Base64 } from "js-base64";
import { Toast } from "vant";
import Exif from "exif-js";

let baseURL;
if (process.env.NODE_ENV !== "production") {
  baseURL = "api/help";
} else {
  baseURL = "https://zsrbactivity.zsnews.cn";
}

export default function useFileUpload() {
  const afterRead = (file) => {
    if (file instanceof Array) {
      file.map((v) => {
        dealFile(v);
      });
    } else {
      dealFile(file);
    }
  };

  const dealFile = (file) => {
    file.status = "uploading";
    file.message = "上传中...";

    if (!/image\/[a-zA-z]+/.test(file.file.type)) {
      alert("请上传图片");
      return false;
    }
    imgPreview(file);
  };

  const imgPreview = (originFile) => {
    var file = originFile.file;
    let Orientation;
    //去获取拍照时的信息，解决拍出来的照片旋转问题
    Exif.getData(file, function () {
      Orientation = Exif.getTag(this, "Orientation");
    });
    // 看支持不支持FileReader
    if (!file || !window.FileReader) return;
    if (/^image/.test(file.type)) {
      // 创建一个reader
      let reader = new FileReader();
      // 将图片2将转成 base64 格式
      reader.readAsDataURL(file);
      // 读取成功后的回调
      reader.onloadend = function () {
        let result = this.result;
        let img = new Image();
        img.src = result;
        //判断图片是否大于500K,是就直接上传，反之压缩图片
        if (this.result.length <= 500 * 1024) {
          // 上传图片
          postImg(this.result, file.name, file.type, originFile);
        } else {
          img.onload = function () {
            const compressedImg = compress(img, Orientation);
            // 上传图片
            postImg(compressedImg, file.name, file.type, originFile);
          };
        }
      };
    }

    // 压缩图片
    const compress = (img, Orientation) => {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      console.log(Orientation);
      // //修复ios上传图片的时候 被旋转的问题
      // if (Orientation != "" && Orientation != 1) {
      //   switch (Orientation) {
      //     case 6: //需要顺时针（向左）90度旋转
      //       rotateImg(img, "left", canvas);
      //       break;
      //     case 8: //需要逆时针（向右）90度旋转
      //       rotateImg(img, "right", canvas);
      //       break;
      //     case 3: //需要180度旋转
      //       rotateImg(img, "right", canvas); //转两次
      //       rotateImg(img, "right", canvas);
      //       break;
      //   }
      // }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.5);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    };

    // 旋转图片
    // const rotateImg = (img, direction, canvas) => {
    //   //最小与最大旋转方向，图片旋转4次后回到原方向
    //   const min_step = 0;
    //   const max_step = 3;
    //   if (img == null) return;
    //   //img的高度和宽度不能在img元素隐藏后获取，否则会出错
    //   let height = img.height;
    //   let width = img.width;
    //   let step = 2;
    //   if (step == null) {
    //     step = min_step;
    //   }
    //   if (direction == "right") {
    //     step++;
    //     //旋转到原位置，即超过最大值
    //     step > max_step && (step = min_step);
    //   } else {
    //     step--;
    //     step < min_step && (step = max_step);
    //   }
    //   //旋转角度以弧度值为参数
    //   let degree = (step * 90 * Math.PI) / 180;
    //   let ctx = canvas.getContext("2d");
    //   switch (step) {
    //     case 0:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.drawImage(img, 0, 0);
    //       break;
    //     case 1:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, 0, -height);
    //       break;
    //     case 2:
    //       canvas.width = width;
    //       canvas.height = height;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, -height);
    //       break;
    //     case 3:
    //       canvas.width = height;
    //       canvas.height = width;
    //       ctx.rotate(degree);
    //       ctx.drawImage(img, -width, 0);
    //       break;
    //   }
    // };
    //将base64转换为文件
    const dataURLtoFile = (dataurl, name, type) => {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, {
        type: type,
      });
    };

    const postImg = (base64, name, type, originFile) => {
      var filedata = dataURLtoFile(base64, name, type);
      const currentTime = new Date().getTime();
      const deadline = currentTime + 1000 * 30;
      const sign = md5(JSON.stringify({ deadline: deadline }));
      const data = Base64.encode(JSON.stringify({ deadline: deadline }));
      const uploadtoken = sign + ":" + data;

      //构造FormData
      let params = new FormData();

      params.append("img", filedata);
      params.append("uploadtoken", uploadtoken);
      const config = {
        headers: {
          //添加请求头
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(baseURL + "/api/common/uploadImg", params, config)
        // .post(
        //   process.env.VUE_APP_BASE_URL + "/api/common/uploadImg",
        //   params,
        //   config
        // )
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              originFile.status = "successed";
              originFile.url = data.data;
              originFile.message = data.msg;
            } else {
              originFile.status = "failed";
              originFile.message = data.error;
            }
          } else {
            originFile.status = "failed";
            originFile.message = "上传失败";
          }
        })
        .catch(() => {
          Toast.fail("网络错误，请重试");
        });
    };
  };

  return {
    afterRead,
  };
}
